import { AlertTriangle } from "lucide-react";

export default function Disclaimer({ text, testid = "disclaimer" }) {
  if (!text) return null;
  return (
    <div
      data-testid={testid}
      className="flex gap-4 rounded-2xl border border-terracotta/20 bg-terracotta-light/60 p-5 lg:p-6"
    >
      <AlertTriangle className="shrink-0 text-terracotta mt-0.5" strokeWidth={1.5} size={20} />
      <p className="text-sm leading-relaxed text-charcoal-700">{text}</p>
    </div>
  );
}
